import React from "react";

export const SectionTitle = ({ title, subtitle }) => (
  <div className="mb-4 p-3 bg-gray-100" style={{ alignContent: "center", display: "grid" }}>
    <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
    <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>
  </div>
);

export const GroupedBarTooltip = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null;
  const visible = payload.filter((p) => p.value > 0);
  if (visible.length === 0) return null;
  return (
    <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", fontSize: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
      <div style={{ fontWeight: 700, marginBottom: 4, color: "#1f2937" }}>Report: {label}</div>
      {visible.map((p) => (
        <div key={p.dataKey} style={{ display: "flex", alignItems: "center", gap: 6, color: "#4b5563" }}>
          <span style={{ width: 8, height: 8, borderRadius: 999, background: p.fill || p.color, display: "inline-block", flexShrink: 0 }} />
          <span>{p.name}: <strong>{p.value}</strong> {p.value === 1 ? "view" : "views"}</span>
        </div>
      ))}
    </div>
  );
};
